import assetPath from '/app/xinglets/lebenslauf/pages/startpage/src/assets/cover-letter-bg.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')